if (!customElements.get('cto-product-financing')) {
  customElements.define(
    'cto-product-financing',
    class ProductFinancing extends HTMLElement {
      constructor() {
        super();

        const url = window.location.href;
        this.selectedOption = this.querySelector('.js-cto-selected-option');
        this.inputs = this.querySelectorAll('.js-cto-financing-input');
        this.summarySelectedOption = document.querySelector('.js-cto-summary-financing');
        this.summarySelectedFinancingPrice = document.querySelector('.js-cto-summary-financing-price');

        // Always select "Pay in full" by default (even when financing UI is hidden)
        if (url.includes('products')) {
          const selectDefault = this.querySelector('input#decline-financing');
          const selectDefaultLabel = this.querySelector('label[for="decline-financing"]');
          const selectedDefaultText = this.querySelector('.js-cto-selected-option');
          // WD - set default value for financing as pay in full - start
          if (selectDefault) {
            // Set checked attribute directly and trigger change event
            selectDefault.checked = true;
            selectDefault.click(); // This ensures all event handlers are triggered
            
            if (selectedDefaultText && selectDefaultLabel) {
              selectedDefaultText.innerText = selectDefaultLabel.innerText;
            }
            
            // Ensure summary elements are updated
            if (this.summarySelectedOption) {
              this.summarySelectedOption.classList.remove('hidden');
            }
            if (this.summarySelectedFinancingPrice) {
              this.summarySelectedFinancingPrice.classList.add('hidden');
            }
          }
          // WD - set default value for financing as pay in full - end
        }


        this.addEvents();
      }

      addEvents() {
        this.inputs.forEach((input) => {
          input.addEventListener('change', () => {
            this.selectedOption.textContent = this.querySelector(`label[for="${input.id}"]`).textContent;

            if (input.value === 'Pay in full') {
              this.summarySelectedOption.classList.remove('hidden');
              this.summarySelectedFinancingPrice.classList.add('hidden');
            } else {
              this.summarySelectedOption.classList.add('hidden');
              this.summarySelectedFinancingPrice.classList.remove('hidden');
            }
          });
        });
      }
    }
  );
}
